import Ads from "../Ads/Ads.component";
import ChanelAd from "../images/ny01.jpg";
import GongqunGroup from "./GongqunGroup.component";
import List from "../ContentList/List.component";
import Item from "../ContentList/Item.component";
import ListHeader from "../ContentList/Header.component";
import { Link } from "react-router-dom";
import Lb from "../images/lb.png";
import { useState, useEffect, useRef } from "react";
import Xft from "../images/xfj.png";
import { useHeaderActive } from "../Context/HeaderActive";
// const GetList = () => {
//   useEffect(() => {
//     async function fetchData() {
//       const res = await fetch("https://htadmin.biandanbao.com/api/random?from=2");
//       const data = await res.json();
//       // console.log(data);
//       return data.data.map((item) => {
//         return {
//           id: item.id,
//           title: item.title,
//           content: item.info.slice(0, 70) + "...",
//           time: item.publish_time_timestamp,
//           type: item.type,
//           from: item.from,
//         };
//       });
//       // setNeedList(data);
//     }
//     return fetchData();
//   }, []);
// };
const Gongqun = () => {
  const [needList2, setNeedList2] = useState([]);
  const [change, setChange] = useState(false);
  const { setActive } = useHeaderActive();
  useEffect(() => {
    setActive(2);
  }, [setActive]);
  useEffect(() => {
    async function fetchData() {
      const res = await fetch(
        "https://htadmin.biandanbao.com/api/random?from=2"
      );
      const data = await res.json();
      // console.log(data);
      setNeedList2(
        data.data.map((item) => {
          return {
            id: item.id,
            title: item.title,
            content: item.info.slice(0, 70) + "...",
            time: item.publish_time_timestamp,
            type: item.type,
            from: item.from,
          };
        })
      );
      // setNeedList(data);
    }
    fetchData();
  }, [change]);
  return (
    <div className="gongqun">
      <div
        style={{ backgroundImage: "url(/images/bg_channel.png)" }}
        className="flex  justify-center"
      >
        <Ads src={ChanelAd} width="1047" height="127" />
      </div>
      <div className="w-[1200px] mx-auto my-[30px]">
        <div className="bg-[#f1f1f1] p-[20px] rounded-[10px]">
          <p className="my-[20px]">
            温馨提示：群内所有服务由商户提供，请联系带"群老板"、"业务员"字样的商户方管理员进行交易，币安担保只提供担保服务
          </p>
          <p className="my-[20px]">
            公群分类快速直达：（ 点击对应分类可以跳转至telegram频道中对应位置 ）
          </p>
          <GongqunGroup
            name="⭐️小额类"
            buttons={[
              {
                name: "币安担保小额公群 - 负责人 @TUSD",
                link: "https://t.me/djdj/4182",
              }
            ]}
          />
          <GongqunGroup
            name="🎮博彩类"
            buttons={[
              {
                name: "必安担保直营综合盘-币游娱乐",
                link: "https://t.me/bayl_bot",
              },
              {
                name: "博彩游戏大群",
                link: "https://t.me/BADBBAGQ/26",
              },
              {
                name: "协议|内幕|球",
                link: "https://t.me/BADBBAGQ/27",
              },
              {
                name: "博彩游戏小群",
                link: "https://t.me/BADBBAGQ/41",
              },
              {
                name: "博彩网站窗口/推广类",
                link: "https://t.me/BADBBAGQ/42",
              }
            ]}
          />
          <GongqunGroup
            name="💰资金类"
            buttons={[
              {
                name: "人头卡商: 银行卡 公户 取现等",
                link: "https://t.me/BADBBAGQ/80",
              },
              {
                name: "码接回U公群",
                link: "https://t.me/BADBBAGQ/74",
              },
              {
                name: "卡接回U公群",
                link: "https://t.me/BADBBAGQ/78",
              },
              {
                name: "白资收出U代付/送存现金承兑",
                link: "https://t.me/BADBBAGQ/79",
              },
              {
                name: "支付宝/微信｜下载付/设置码",
                link: "https://t.me/BADBBAGQ/82",
              },
              {
                name: "资金窗口:招车 找料 跑分通道",
                link: "https://t.me/BADBBAGQ/82",
              },
              {
                name: "核销/回收:香烟 礼品卡 币/话费类",
                link: "https://t.me/BADBBAGQ/81",
              }
            ]}
          />
          <GongqunGroup
            name="📱手机口"
            buttons={[
              {
                name: "手机口类一区",
                link: "https://t.me/BADBBAGQ/83",
              },
              {
                name: "手机口类二区",
                link: "https://t.me/BADBBAGQ/84",
              },
              {
                name: "手机口类三区",
                link: "https://t.me/BADBBAGQ/85",
              },
              {
                name: "手机口类四区",
                link: "https://t.me/BADBBAGQ/86",
              },
              {
                name: "手机口类五区",
                link: "https://t.me/BADBBAGQ/87",
              },
              {
                name: "手机口类六区",
                link: "https://t.me/taibei/145",
              },
              {
                name: "有线/无线/呼叫转移/接听口/微信口",
                link: "https://t.me/BADBBAGQ/125",
              }
            ]}
          />
          <GongqunGroup
            name="👤账号类"
            buttons={[
              {
                name: "账号买卖公群",
                link: "https://t.me/BADBBAGQ/88",
              },
              {
                name: "账号租赁一区",
                link: "https://t.me/BADBBAGQ/89",
              },
              {
                name: "账号租赁二区",
                link: "https://t.me/BADBBAGQ/127",
              },
              {
                name: "租PCZM一区",
                link: "https://t.me/BADBBAGQ/90",
              },
              {
                name: "租PCZM二区",
                link: "https://t.me/BADBBAGQ/91",
              },
              {
                name: "租PCZM三区",
                link: "https://t.me/BADBBAGQ/92",
              },
              {
                name: "租苹果ID",
                link: "https://t.me/taibei/126",
              }
            ]}
          />
          <GongqunGroup
            name="↗️代发类"
            buttons={[
              {
                name: "⚡️视频代发一区",
                link: "https://t.me/BADBBAGQ/93",
              },
              {
                name: "⚡️视频代发二区",
                link: "https://t.me/BADBBAGQ/94",
              },
              {
                name: "⚡️视频代发三区",
                link: "https://t.me/BADBBAGQ/95",
              },
              {
                name: "⚡️视频代发四区",
                link: "https://t.me/BADBBAGQ/128",
              },
              {
                name: "🎙直播评论刷礼",
                link: "https://t.me/BADBBAGQ/124",
              },
              {
                name: "💬话术单代聊类",
                link: "https://t.me/BADBBAGQ/96",
              },
              {
                name: "💬im短彩信代发",
                link: "https://t.me/BADBBAGQ/97",
              }
            ]}
          />
          <GongqunGroup
            name="🚀推广类"
            buttons={[
              {
                name: "拉手 Q拉 V拉",
                link: "https://t.me/BADBBAGQ/98",
              },
              {
                name: "拉手 Q拉 V拉",
                link: "https://t.me/BADBBAGQ/99",
              },
              {
                name: "收粉引流收量",
                link: "https://t.me/BADBBAGQ/100",
              },
              {
                name: "地推贴纸电销",
                link: "https://t.me/BADBBAGQ/106",
              }
            ]}
          />
          <GongqunGroup
            name="🛎服务类"
            buttons={[
              {
                name: "T G 电报业务",
                link: "https://t.me/BADBBAGQ/107",
              },
              {
                name: "TRX能量闪兑",
                link: "https://t.me/BADBBAGQ/108",
              },
              {
                name: "苹果ID贷款类",
                link: "https://t.me/BADBBAGQ/115",
              },
              {
                name: "成人服务公群",
                link: "https://t.me/BADBBAGQ/118",
              },
              {
                name: "天眼查档/接码/实名/注册/解封",
                link: "https://t.me/BADBBAGQ/110",
              },
              {
                name: "服务器 机器人 百度推广技术类",
                link: "https://t.me/BADBBAGQ/114",
              },
              {
                name: "票务证件签证/UI设计美工翻译",
                link: "https://t.me/BADBBAGQ/113",
              },
              {
                name: "代办:代买/接代报警/酒店招聘类/代孕捐卵类",
                link: "https://t.me/BADBBAGQ/101",
              }
            ]}
          />
          <GongqunGroup
            name="🛒实物类"
            buttons={[
              {
                name: "香烟酒水茶叶/成人异品道具馆",
                link: "https://t.me/BADBBAGQ/119",
              },
              {
                name: "手机卡收售/手机星链电子数码",
                link: "https://t.me/BADBBAGQ/120",
              },
              {
                name: "金银翡钻玉/金包乌/潮服饰箱包",
                link: "https://t.me/BADBBAGQ/122",
              }
            ]}
          />
          <GongqunGroup
            name="💡其它类"
            buttons={[
              {
                name: "网赚/培训/教程｜算命解灾转运",
                link: "https://t.me/BADBBAGQ/123",
              },
              {
                name: "运费险/快递单/快递代发代取类",
                link: "https://t.me/BADBBAGQ/121",
              }
            ]}
          />
        </div>
        <div className="gongqun_recommend my-[20px]">
          <List>
            <ListHeader>
              <div className="flex flex-row justify-between mb-[30px] relative	pl-[40px] pr-[30px]">
                <img
                  src={Lb}
                  className="absolute left-[10px] top-[12px] w-[26px] h-[26px] "
                />
                <div className=" pl-1 text-[#b36a12] text-[30px]">
                  最新公群
                  <span className="text-[#33abe0] relative">
                    <img
                      src={Xft}
                      alt=""
                      className="w-[32px] h-[32px] inline absolute top-[5px] left-[20px]"
                    />
                    <span className="ml-[65px]">
                      {/* <Link to="https://t.me/BIAN">@BIAN</Link>
                  {` `} */}
                      <Link to="https://t.me/BADB" className="text-[30px]">
                        @BADB
                      </Link>
                    </span>
                  </span>
                </div>
                <span
                  className="text-[#565656] text-[14px] leading-[28px] self-center cursor-pointer"
                  onClick={() => setChange(!change)}
                >
                  换一批
                </span>
              </div>
            </ListHeader>
            <div className="flex flex-row flex-wrap justify-start gap-[18px]">
              {needList2.map((item, index) => (
                <Item key={index} item={item} />
              ))}
            </div>
          </List>
        </div>
      </div>
    </div>
  );
};

export default Gongqun;
